export const transporterList = [
  {
    name: "Delhivery",
    image: "/brandLogos/delhiverynew size.jpg",
    transporterId: "06AAPCS9575E1ZR",
  },
  {
    name: "Xpressbees",
    image: "/brandLogos/xpressbeesnew size.jpg",
    transporterId: "27AAGCB3904P2ZC",
  },
  {
    name: "Bluedart",
    image: "/brandLogos/blue dartnew size.jpg",
    transporterId: "27AAACB0446L1ZS",
  },
  {
    name: "DTDC",
    image: "/brandLogos/dtdcnew size.jpg",
    transporterId: "88AAACD8017H1ZX",
  },
  {
    name: "Ekart",
    image: "/brandLogos/ekartnew size.jpg",
    transporterId: "07AADCI8374D2ZH",
  },
  {
    name: "Safexpress",
    transporterId: "88AAECS4363H1ZA",
  },
  {
    name: "Ecom Express",
    image: "/brandLogos/ecom expressnew size.jpg",
    transporterId: "07AADCE1344F1Z2",
  },
  {
    name: "Gati",
    image: "/brandLogos/Gatinew size.jpg",
    transporterId: "36AADCG2096A1ZY",
  },
  {
    name: "TCI Express",
    transporterId: "06AADCT0663J4Z9",
  },
  {
    name: "Oxyzen",
    transporterId: "88AADCO5675P1ZU",
  },
  {
    name: "Scorpion Express",
    transporterId: "88AAJCS7860C1ZK",
  },
  {
    name: "DP World",
    image: "/brandLogos/dp worldnew size.jpg",
    transporterId: "88AADCD1983D1ZS",
  },
  {
    name: "Movin",
    image: "/brandLogos/movinnew size.jpg",
    transporterId: "88AAFCI7460Q1ZW",
  },
  {
    name: "Rivigo",
    transporterId: "27AACCV3947L1ZU",
  },
  {
    name: "Smartr",
    image: "/brandLogos/smartrnew size.jpg",
    transporterId: "88ABBCS3441C1ZQ",
  },
];
